module.exports = __webpack_public_path__ + "static/media/todolist--mockup.3bcb0b49.png";